import {
    IconContainer,
    MenuItem,
    MenuText,
    MenuTitle,
    MenuTitleContainer,
    StyledMenu,
} from "./Menu.styles";
import React from "react";
import { MAIN_COLOR } from "../../globalThemes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF } from "@fortawesome/free-brands-svg-icons/faFacebookF";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons/faEnvelope";
import { StyledPartnerLogo } from "../../logos/partners/ErnestBiesLogo/ErnestBiesLogo.styles";
import "./Menu.styles.css";
import {
    CONTACT_EMAIL,
    FACEBOOK_PAGE,
    WEBSITE_URL_PARTNER,
} from "../../../utils/info";

const Menu = () => (
    <StyledMenu>
        <MenuItem href={FACEBOOK_PAGE} target={"_blank"}>
            <FontAwesomeIcon
                icon={faFacebookF}
                color={MAIN_COLOR}
                className={"menu-icon"}
            />
            <MenuTitleContainer>
                <MenuTitle>{"Facebook"}</MenuTitle>
                <MenuText>{"Bądź na bieżąco! Zostaw lajka!"}</MenuText>
            </MenuTitleContainer>
        </MenuItem>
        <MenuItem href={"mailto:" + CONTACT_EMAIL}>
            <FontAwesomeIcon
                icon={faEnvelope}
                color={MAIN_COLOR}
                className={"menu-icon"}
            />
            <MenuTitleContainer>
                <MenuTitle>{CONTACT_EMAIL}</MenuTitle>
                <MenuText>{"Skontaktuj się z nami!"}</MenuText>
            </MenuTitleContainer>
        </MenuItem>
        <MenuItem href={WEBSITE_URL_PARTNER} target={"_blank"}>
            <IconContainer>
                <StyledPartnerLogo
                    alt={"EB"}
                    src={"/eb-logo-green.svg"}
                    resizable
                />
            </IconContainer>
            <MenuTitleContainer>
                <MenuTitle>{"ernestbies.com"}</MenuTitle>
                <MenuText>{"Odwiedź stronę naszego partnera!"}</MenuText>
            </MenuTitleContainer>
        </MenuItem>
    </StyledMenu>
);

export default Menu;
